import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmDialog } from '@klareospace/pharos-lib-web-utils';

import { useArchiveVehicle } from '../hooks';

// ─── Types ────────────────────────────────────────────────────────────────────

interface ArchiveVehicleDialogProps {
  onClose: () => void;
  vehicleId: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function ArchiveVehicleDialog({ onClose, vehicleId }: ArchiveVehicleDialogProps): React.JSX.Element {
  const { t: tCommon } = useTranslation('common');
  const { t } = useTranslation('settings');
  const archiveVehicle = useArchiveVehicle();

  function handleConfirm(): void {
    if (archiveVehicle.isPending) return;
    archiveVehicle.mutate(vehicleId, { onSettled: () => onClose() });
  }

  function handleOpenChange(open: boolean): void {
    if (!open) onClose();
  }

  return (
    <ConfirmDialog
      cancelLabel={tCommon('actions.cancel')}
      confirmLabel={tCommon('actions.archive')}
      description={t('vehicles.actions.archive.dialog.description')}
      destructive
      isPending={archiveVehicle.isPending}
      onConfirm={handleConfirm}
      onOpenChange={handleOpenChange}
      open={!!vehicleId}
      title={t('vehicles.actions.archive.dialog.title')}
    />
  );
}
